module.exports = __webpack_public_path__ + "files/1789eb62f43d25d26d5e2839be5f6540.png";